// Tiroir de menu mobile : <dialog> modal (focus piégé et Échap natifs).
(() => {
  const dialog = document.querySelector('[data-adc-menu]');
  const openBtn = document.querySelector('[data-adc-menu-open]');
  if (!dialog || !openBtn) return;
  const closeBtn = dialog.querySelector('[data-adc-menu-close]');

  const open = () => {
    dialog.showModal();
    document.documentElement.classList.add('adc-lock');
    openBtn.setAttribute('aria-expanded', 'true');
    closeBtn && closeBtn.focus();
    if (typeof window.adcTrack === 'function') window.adcTrack('menu_ouvert');
  };
  const close = () => { if (dialog.open) dialog.close(); };

  openBtn.addEventListener('click', open);
  closeBtn && closeBtn.addEventListener('click', close);
  // Un lien du tiroir (ancre de la même page comprise) ferme le menu avant la navigation.
  dialog.addEventListener('click', (e) => { if (e.target.closest('a[href]')) close(); });
  dialog.addEventListener('close', () => {
    document.documentElement.classList.remove('adc-lock');
    openBtn.setAttribute('aria-expanded', 'false');
    openBtn.focus({ preventScroll: true });
  });
  window.matchMedia('(min-width: 1200px)').addEventListener('change', (e) => { if (e.matches) close(); });
})();
